import React, { useEffect, useState, useRef } from "react";
import * as XLSX from "xlsx";

function ExcelHandler(props) {
  const [subItemGroups, setSubItemGroups] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploaded, setUploaded] = useState(false);
  const [amount, setAmount] = useState(0);
  const [done, setDone] = useState(0);
  const fileInputRef = useRef(null); // Reference for the file input

  useEffect(() => {
    if (done === amount && done > 0) {
      setUploaded(true);
      props.refresh();

      // Clear the file input
      if (fileInputRef.current) {
        resetFields();
      }
    }
  }, [done]);

  function resetFields() {
    fileInputRef.current.value = "";
    setDone(0);
    setAmount(0);
    setUploading(false);
    setTimeout(() => {
      setUploaded(false);
    }, 1000);
  }

  useEffect(() => {
    fetch(
      "https://inventy.redata.se/inventdb/api-itemSubGroup.php?Command=Select",
    )
      .then((response) => response.json())
      .then((data) => {
        const transformedData = {};

        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            const item = data[key];
            transformedData[item.Name.toLowerCase()] = {
              ID: item.ID,
              ItemGroupID: item.ItemGroupID,
            };
          }
        }

        setSubItemGroups(transformedData);
      })
      .catch((error) => console.error("Error fetching data: ", error));
  }, []);

  function startUpload(data) {
    setUploaded(false);
    let index = 0;

    const intervalId = setInterval(() => {
      if (index < data.length) {
        upload(data[index]);
        index++;
      } else {
        clearInterval(intervalId);
      }
    }, 250);
  }

  function upload(data) {
    console.log(data);
    fetch("https://inventy.redata.se/inventdb/api_addProducts.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        setDone((prevState) => prevState + 1);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  useEffect(() => {
    console.log(subItemGroups);
  }, [subItemGroups]);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const data = XLSX.utils.sheet_to_json(ws, { header: 1 });

      // Skip the header row and start processing from the second row
      const rows = data.slice(1);

      // Map each row into the desired object format for inputFields
      const newInputFields = rows
        .filter((row) => row.some((cell) => !!cell)) // Filter out empty rows
        .map((row) => {
          let { ID, ItemGroupID } = subItemGroups[row[4]?.toLowerCase()] || {};

          return {
            Name: row[0] || "", // Assuming the 'Anställd' column is the first column
            EAN1: row[1] || "",
            Price: row[2] || "",
            Volume: row[3] || "",
            ItemGroupID: ItemGroupID || "1",
            ItemSubGroupID: ID || "1",
          };
        });

      // Update the state with the new input fields
      setAmount(newInputFields.length);
      setUploading(true);
      startUpload(newInputFields);
    };
    reader.readAsBinaryString(file);
  };

  const insertGoodNameHere = {
    position: "absolute",
    top: "50px",
    left: "50%",
    transform: "translateX(-50%)",
  };

  return (
    <div>
      <input
        type="file"
        accept=".xlsx, .xls"
        onChange={handleFileUpload}
        ref={fileInputRef}
        style={{ width: "200px" }}
      />
      {uploading && !uploaded && (
        <progress
          value={done}
          max={amount}
          style={insertGoodNameHere}
        ></progress>
      )}
      {uploaded && <p style={insertGoodNameHere}>Produkter tillagda</p>}
    </div>
  );
}

export default ExcelHandler;
